<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <list @form="dialog = true" @clear="$refs.form.clear()" />
        <form-manager ref="form" :dialog="dialog" @close="dialog = false" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FormManager from './FormManager'
import List from './List'

export default {
  name: 'Roles',
  components: {
    List,
    FormManager,
  },
  data() {
    return {
      dialog: false,
    }
  },
  mounted() {
    this.$store.dispatch('roles/resetState')
    this.initData()
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
    }),
  },
  methods: {
    ...mapActions({
      fetchRoles: 'roles/fetchList',
      fetchPermissions: 'roles/fetchPermissionList',
      setStatus: 'events/setStatus',
    }),
    async initData() {
      // this.resetPagitations()
      await Promise.all([
        this.fetchRoles({ limit: 0 }),
        this.fetchPermissions(),
      ])
    },
  },
  watch: {
    statusOfButton: function (val) {
      if (val) {
        this.initData().finally(() => {
          this.setStatus(false)
        })
      }
    },
  },
}
</script>
